webpackJsonp([177183124757209],{

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _colouredCard = __webpack_require__(61);
	
	var _globalStyles = __webpack_require__(4);
	
	var _colourManager = __webpack_require__(173);
	
	var _detail = __webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MakeADonationPage = function (_React$PureComponent) {
		_inherits(MakeADonationPage, _React$PureComponent);
	
		function MakeADonationPage() {
			_classCallCheck(this, MakeADonationPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		MakeADonationPage.prototype.render = function render() {
			var pageSettings = this.props.data.page.edges[0].node;
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.heading }),
					_react2.default.createElement('meta', { name: 'description', content: 'Donate now to help people living with, or affected by an eating disorder today.' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'Donate now to help people living with, or affected by an eating disorder today.' })
				),
				_react2.default.createElement(
					'section',
					{ className: _detail.wrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _detail.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.detailSideBarLayout.wrapper },
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.detailSideBarLayout.leftSide },
								_react2.default.createElement(
									'div',
									{ className: (0, _globalStyles.contentSection)('#fff') },
									_react2.default.createElement(
										'header',
										null,
										_react2.default.createElement(
											'h1',
											{ className: _detail.titleStyle },
											pageSettings.heading
										)
									),
									_react2.default.createElement('div', {
										className: _detail.textStyle,
										dangerouslySetInnerHTML: { __html: pageSettings.body }
									}),
									_react2.default.createElement(
										'div',
										{ className: _detail.innerWrapperStyle },
										_react2.default.createElement(
											'section',
											{ className: _detail.cardsSectionStyle },
											pageSettings.tiles.map(function (tile, i) {
												return _react2.default.createElement(_colouredCard.ColouredCard, {
													id: i,
													key: i,
													background: (0, _colourManager.descriptionToHex)(tile.colour),
													href: tile.link_destination,
													title: tile.heading,
													body: tile.body,
													minHeight: 200,
													arrow: true
												});
											})
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return MakeADonationPage;
	}(_react2.default.PureComponent);
	
	MakeADonationPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						tiles: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							heading: _propTypes2.default.string,
							body: _propTypes2.default.string,
							link_destination: _propTypes2.default.string,
							colour: _propTypes2.default.string
						}))
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = MakeADonationPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-get-involved-make-a-donation-index-js-e89485fe94b9c47eb1e9.js